import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL, APP_CONFIG, ConfigSettings } from '@shared/config';
import { ApiResponse, Dimension } from '@shared/models';
import { Observable } from 'rxjs';

@Injectable()
export class DataApiService {
  globalSettings: ConfigSettings;

  private readonly dimensionsUrl: string;
  private readonly metricsUrl: string;
  private readonly filtersUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) settings: ConfigSettings
  ) {
    this.globalSettings = settings;
    this.dimensionsUrl = `${this.globalSettings.dataApiUrl}${API_URL.dataApiDimensions}`;
    this.metricsUrl = `${this.globalSettings.dataApiUrl}${API_URL.dataApiMetric}`;
    this.filtersUrl = `${this.globalSettings.dataApiUrl}${API_URL.filters}`;
  }

  public getDataSourceNames(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${this.globalSettings.dataApiUrl}${API_URL.dataApiDataSourceNames}`,
      { withCredentials: true }
    );
  }

  public getMetricsNames(dataSourceId?: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${this.metricsUrl}${API_URL.metricsNames}/${dataSourceId}`,
      { withCredentials: true }
    );
  }

  public getDimensionsNames(
    dataSourceId?: string
  ): Observable<ApiResponse<Dimension[]>> {
    return this.http.get<ApiResponse<Dimension[]>>(
      `${this.dimensionsUrl}${API_URL.dimensionsNames}/${dataSourceId}`,
      {
        withCredentials: true,
      }
    );
  }

  public getDimensionName(
    dimensionId?: string
  ): Observable<ApiResponse<Dimension>> {
    return this.http.get<ApiResponse<Dimension>>(
      `${this.dimensionsUrl}/${dimensionId}`,
      {
        withCredentials: true,
      }
    );
  }

  public getMetricName(metricId?: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.metricsUrl}/${metricId}`, {
      withCredentials: true,
    });
  }

  public getAllDimensionsNames(): Observable<ApiResponse<Dimension[]>> {
    return this.http.get<ApiResponse<Dimension[]>>(
      `${this.dimensionsUrl}${API_URL.dimensionsNames}/`,
      {
        withCredentials: true,
      }
    );
  }

  public getFilterNames(dataSourceId?: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${this.filtersUrl}${API_URL.filtersNames}/${dataSourceId}`,
      {
        withCredentials: true,
      }
    );
  }
}
